export enum ComparisonOperator {
  equals = 'equals',
  notEqual = 'notequal',
  startsWith = 'startswith',
  contains = 'contains',
  doesNotContain = 'doesnotcontain',
  endsWith = 'endswith',
  greaterThan = 'gt',
  greaterThanOrEqualTo = 'gte',
  lessThan = 'lt',
  lessThanOrEqualTo = 'lte',
}
